<template>
  <div class="mt-custom">
    <b-tabs justified pills variant="outline-primary" v-if="isStudent">
      <b-tab title="Messages privés" active class="py-5">
        <UnitEmpty v-if="isEmptyPrivateMsgs" class="my-5" />
        <UnitLoading v-if="isLoadingMessages" class="my-5" />
        <div
          v-for="(m, i) in privateMsgs.data.data.data"
          :key="`${i}-${m.id}`"
          class="px-2"
        >
          <UnitMessage :comment="m.comment" :message="m" :goMsg="true" />
        </div>
      </b-tab>
      <b-tab class="py-5">
        <template v-slot:title>
          <strong class="mr-2">Messages à tous</strong>
          <b-icon
            icon="exclamation-circle-fill"
            variant="warning"
            v-if="jobs.showGlobalMsgIcon"
          ></b-icon>
        </template>
        <UnitGeneralMessage />
      </b-tab>
    </b-tabs>
    <div class="py-4" v-if="isTeacher">
      <UnitEmpty v-if="isEmptyPrivateMsgs" class="my-5" />
      <UnitLoading v-if="isLoadingMessages" class="my-5" />
      <div
        v-for="(m, i) in privateMsgs.data.data.data"
        :key="`${i}-${m.id}`"
        class="px-2 py-3 border-bottom"
        :class="{ 'border-top mt-2': i === 0 }"
      >
        <UnitMessage :comment="m.comment" :message="m" :goMsg="true" />
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @file       Deliberation inbox component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import UnitMessage from "@/modules/comments/components/unitMessage.vue";
import UnitEmpty from "@/modules/comments/components/unitEmpty.vue";
import UnitLoading from "@/modules/comments/components/unitLoading.vue";
import UnitGeneralMessage from "@/modules/comments/components/unitGeneralMessage.vue";
import { commentsMixin } from "@/modules/comments/mixins.js";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "Inbox",
  mixins: [commentsMixin],
  components: { UnitMessage, UnitEmpty, UnitLoading, UnitGeneralMessage },

  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store.commit("comments/setCommentsFilters", {
      reset: true
    });
    store
      .dispatch("deliberations/getDlibr", {
        params: { teacher: to.params.teacher, url: to.params.url }
      })
      .then(({ data }) => {
        next(() => {
          const profile = store.state.auth.profile.data.data.find(u => u);
          const dlibrId = data.data.find(d => d).id;
          store.commit("comments/setGeneralMsgsFilters", {
            reset: true,
            fields: {
              user: profile.id,
              deliberation: dlibrId,
              old: true
            }
          });
          let user = profile.role == "teacher" ? {} : { user: profile.id };
          store.commit("comments/setPrivateMsgsFilters", {
            reset: true,
            fields: {
              ...user,
              deliberation: dlibrId,
              all: true
            }
          });
          Promise.all([
            store.dispatch("comments/getGeneralMsgs"),
            store.dispatch("comments/getPrivateMsgs")
          ]);
        });
      })
      .catch(() => {
        next(vm => {
          vm.$root.$bvToast.toast(
            "Aucune délibération trouvée pour cette URL",
            {
              title: "Erreur",
              variant: "danger"
            }
          );
          vm.$router.push({ name: "home" });
        });
      });
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    /**
     * Check if empty private messages.
     * 
     * @return  {Bool}    true or false
     */
    isEmptyPrivateMsgs() {
      return (
        this.privateMsgs.status === "success" &&
        Object.keys(this.privateMsgs.data.data.data).length === 0
      );
    },

    /**
     * Check if loading messages.
     * 
     * @return  {Bool}    true or false
     */
    isLoadingMessages() {
      return this.privateMsgs.status === "fetching";
    }
  },
  mounted() {
    if (!this.isActiveJobs) {
      this.onActiveJobs();
    }
  }
};
</script>
<style lang="scss" scoped>
.mt-custom {
  margin-top: -30px;
}

/deep/ div > ul.nav {
  position: fixed;
  left: 0 !important;
  width: 100% !important;
  margin-top: -34px !important;
  padding-top: 25px;
  padding-bottom: 10px;
  padding-left: 20%;
  padding-right: 20%;
  background-color: white !important;
  z-index: 100 !important;
  -webkit-box-shadow: 0px 1px 1px #f8f9fa;
  -moz-box-shadow: 0px 1px 1px #f8f9fa;
  box-shadow: 0px 1px 1px #f8f9fa;
}

@media (max-width: 768px) {
  /deep/ div > ul.nav {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>
